import { TrFun } from "./types";

export const getPurchaseOrPatientFieldName = (hasOnlyPatients: boolean, hasOnlyPurchases: boolean, t: TrFun) =>
	(hasOnlyPatients && t("patientId")) || (hasOnlyPurchases && t("purchaseId")) || `${t("purchaseOrPatientId")}`;

export const getCaseOrAgreementIdFieldName = (hasOnlyPatients: boolean, hasOnlyPurchases: boolean, t: TrFun) =>
	(hasOnlyPatients && t("case-id")) || (hasOnlyPurchases && t("agreement-id")) || `${t("caseOrAgreementId")}`;

export const getAdministrationOrPurchaseDateFieldName = (hasOnlyPatients: boolean, hasOnlyPurchases: boolean, t: TrFun) =>
	(hasOnlyPatients && t("administrationDate")) || (hasOnlyPurchases && t("purchaseDate")) || `${t("administrationOrPurchaseDate")}`;
